import { render } from "./button.vue?vue&type=template&id=1be5714e"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"
script.render = render

export default script